import { Component, Input, OnInit, input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'ziro-multi-step-animation',
  templateUrl: './multi-step-animation.component.html',
  standalone: false,
})
export class MultiStepAnimationComponent implements OnInit {
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() currentStep = 1;
  readonly steps = input<AnimationOptions[]>();
  readonly animationStart$ = input(new Observable<number>());
  replaySubjects: Subject<void>[];

  ngOnInit(): void {
    this.replaySubjects = this.steps().map(() => new Subject<void>());
    this.animationStart$().subscribe((step: number) => {
      if (this.replaySubjects[step - 1]) {
        this.currentStep = step;
        this.replaySubjects[step - 1].next();
      }
    });
  }
}
